var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { Wrapper } from './styles';
import MoreListings from '@spa/offer/components/MoreListings';
import { WishlistContextProvider } from '@spa/shared/contexts/wishlist';
import { trackMorePlacesLikeThis } from '@spa/offer/store/actions/tracking';
var MorePlacesLikeThis = function MorePlacesLikeThis(_ref) {
  var _recommendations$data;
  var recommendations = _ref.recommendations,
    trackMorePlacesLikeThisAction = _ref.trackMorePlacesLikeThisAction;
  if (!(recommendations !== null && recommendations !== void 0 && (_recommendations$data = recommendations.data) !== null && _recommendations$data !== void 0 && _recommendations$data.length)) {
    return null;
  }
  return __jsx(Wrapper, null, __jsx(WishlistContextProvider, null, __jsx(MoreListings, {
    title: "More places like this",
    recommendations: recommendations,
    disableWishlist: false,
    cardWidth: 291,
    cardGap: 12,
    trackListing: trackMorePlacesLikeThisAction,
    showTrustedTag: true
  })));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$offer$recommend = _ref2.offer.recommendations;
  _ref2$offer$recommend = _ref2$offer$recommend === void 0 ? {} : _ref2$offer$recommend;
  var recommendations = _ref2$offer$recommend.byOffer;
  return {
    recommendations: recommendations
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackMorePlacesLikeThisAction: function trackMorePlacesLikeThisAction() {
      return dispatch(trackMorePlacesLikeThis());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MorePlacesLikeThis);